import React from 'react';
import {Text} from '../Text';

export function Loading(props) {
  return (
    <div 
      style={{
        width:'100%', 
        height:'100%', 
        display:'flex', 
        alignItems:'center', 
        justifyContent:'center',
        ...props.style,
      }}>
      <Text small>Loading...</Text>
    </div>
  );
}